import { render } from "./Promocion.vue?vue&type=template&id=326e571c"
import script from "./Promocion.vue?vue&type=script&lang=js"
export * from "./Promocion.vue?vue&type=script&lang=js"

import "./Promocion.vue?vue&type=style&index=0&id=326e571c&lang=css"
import "./Promocion.vue?vue&type=style&index=1&id=326e571c&lang=css"
import "./Promocion.vue?vue&type=style&index=2&id=326e571c&lang=css"
import "./Promocion.vue?vue&type=style&index=3&id=326e571c&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__